import {EntitetType, Modelloppdatering, MøteId, OppdateringmodellEntitetMedForelder} from "../tjenester/ressurser/generertNg2HttpKlient";

export function i18nArgumenterMedAnsvarligBruker(oppdatering: Modelloppdatering<any>, ytterligereFelter: Record<string, string> = {}): Record<string, string> {
    return {
        bruker: oppdatering.ansvarligBruker?.navn ?? '',
        ...ytterligereFelter
    }
}

export function møteIdFraForeldre(hendelse: Modelloppdatering<OppdateringmodellEntitetMedForelder>): MøteId | null {
    return hendelse.modell.foreldre.find(kandidat => kandidat.type == EntitetType.møte)?.id ?? null;
}

export function modell<T>(modell: Modelloppdatering<any>): T {
    return modell.modell as T;
}
